<div class="form-modal">
    <div class="form-modal__body">
        <div class="form-wrapper-80">
            <div class="title-wrapper">
                <h2 translate>Additional information</h2>
            </div>
            <p>
                This information is collected to help better understand the users that are
                using WellTrack Boost. Your personal information is never shared with anyone without your consent, and your
                organization will only view this information as an aggregate.
            </p>
        </div>

        <div class="form-wrapper">
            <form [formGroup]="demographicForm" (ngSubmit)="doSave()">

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="branch">Military Branch</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-branch"
                        id="branch"
                        [(ngModel)]="branch"
                        aria-required="true"
                        (ngModelChange)="onBranchChange($event)"
                        formControlName="branch">
                        <option value="">Military Branch</option>
                        <option *ngFor="let branch of branches" [value]="branch">{{branch}}</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.branch.errors">
                    Please select your military branch
                </div>

                <div *ngIf="branch !== 'Family Member of Veteran' && branch !== 'OptumServe Staff'">
                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="from">From — Years Served</label>
                        <select
                            class="app-c-form-control wt-auto-demographic-from"
                            id="from"
                            [(ngModel)]="from"
                            aria-required="true"
                            formControlName="from">
                            <option value="">Years Served</option>
                            <option *ngFor="let yearServed of yearsServed" [value]="yearServed">{{yearServed}}</option>
                        </select>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="to">To</label>
                        <select
                            class="app-c-form-control wt-auto-demographic-to"
                            id="to"
                            [(ngModel)]="to"
                            aria-required="true"
                            formControlName="to">
                            <option value="">Select</option>
                            <option *ngFor="let yearServed of yearsServed" [value]="yearServed">{{yearServed}}</option>
                        </select>
                    </div>

                    <div class="red error-message" *ngIf="submitted && ((f.from && f.from.errors) || (f.to && f.to.errors))">
                        Please select the years served
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="gender">Gender</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-gender"
                        id="gender"
                        [(ngModel)]="gender"
                        aria-required="true"
                        formControlName="gender">
                        <option value="">Gender</option>
                        <option *ngFor="let genderRow of genderRows" [value]="genderRow">{{genderRow}}</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.gender.errors">
                    Please select a gender
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="ethnicity">Race</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-ethnicity"
                        id="ethnicity"
                        [(ngModel)]="ethnicity"
                        aria-required="true"
                        formControlName="ethnicity">
                        <option value="">Race</option>
                        <option *ngFor="let ethnicityRow of ethnicityRows" [value]="ethnicityRow">{{ethnicityRow}}</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.ethnicity.errors">
                    Please select a race
                </div>

                <div class="app-c-form-group" *ngIf="ethnicity === 'Other Race/Ethnicity'">
                    <input
                        class="app-c-form-control"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Please share your ethnicity"
                        [(ngModel)]="otherEthnicity"
                        aria-required="true" />
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="age">Age Range</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-age"
                        id="age"
                        [(ngModel)]="age"
                        aria-required="true"
                        formControlName="age">
                        <option value="">Age Range</option>
                        <option *ngFor="let age of ages" [value]="age">{{age}}</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.age.errors">
                    Please select an age
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="nativeLanguage">Is English your native language?</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-referred"
                        id="nativeLanguage"
                        [(ngModel)]="nativeLanguage"
                        aria-required="true"
                        formControlName="nativeLanguage">
                        <option [value]="1">Yes</option>
                        <option [value]="0">No</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.nativeLanguage.errors">
                    Please select a native language
                </div>

                <div class="app-c-form-group" *ngIf="nativeLanguage === 0">
                    <input
                        class="app-c-form-control wt-auto-demographic-other"
                        [ngModelOptions]="{standalone: true}"
                        aria-label="Please share your native and/or preferred language"
                        placeholder="Please share your native and/or preferred language"
                        [(ngModel)]="otherLanguage"
                        aria-required="true" />
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="state">What state do you live in?</label>
                    <select
                        class="app-c-form-control wt-auto-demographic-referred"
                        id="state"
                        [(ngModel)]="region"
                        aria-required="true"
                        formControlName="state">
                        <option value="">What state do you live in?</option>
                        <option *ngFor="let state of states" [value]="state">{{state}}</option>
                    </select>
                </div>

                <div class="red error-message" *ngIf="submitted && f.state.errors">
                    Please select your state
                </div>

                <button tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve wt-auto-demographic-save">Save</button>

            </form>
        </div>
    </div>
</div>
